import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardText, ListGroup, ListGroupItem } from 'react-bootstrap';
import HeroBackground from '../HeroBackground';

const SearchDirectory = () => {
  const [searchTerm, setSearchTerm] = useState(''); 
  const [searchTermLocation, setSearchTermLocation] = useState(''); 
  const [selectedRegion, setSelectedRegion] = useState(''); 
  const [selectedPosition, setSelectedPosition] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [selectedUnion, setSelectedUnion] = useState('');
  const [selectedLocal, setSelectedLocal] = useState('');   
  const [data, setData] = useState([]); 

  const [isLoaded, setIsLoaded] = useState(false); 
  const [error, setError] = useState(null); 
  const regions = ['Central', 'East', 'Dallas Fort Worth', 'Gulf Coast', 'Panhandle', 'West']; 
  const position =[
    'actor', 'producer', 'executive producer', 'co-executive producer',
    'showrunner', 'unit production manager', 'production coordinator', 'director', 
    'assistant director', ' 1st assistant director', '2nd assistant director', 
    'camera operator',  'key hair', 'key makeup', 'production accountant',
    '1st assistant accountant', 'writer', 'sound mixer', 'boom operator', 
    'location manager', 'assistant location manager', 'key grip', 'best boy grip', 
    'gaffer', 'best boy electric', 'transportation coordinator', 'picture car coordinator',
    'key set costumer', 'buyer', 'set decorator', 'lead man', 'production designer', 'art director',
    'music supervisor', 'composer', 'spfx coordinator', 'spfx buyer', 'editor', 'assistant editor',
    ];
    const department = [
      'Production', 'Accounting', 'Talent', 'Writer', 'Camera', 'Sound', 'Construction', 'Art Department', 'Set Dec',
      'Grip', 'Electric', 'Stunts', 'Costumes', 'Hair and Makeup', 'Craft Services', 'Medic', 'Locations', 'Transportation', 'Music', 'Post Production', 'SPFX',
    ]

    const fetchData = async () => {
      // console.log('Fetching data...');
      setIsLoaded(false);
      try {
        const response = await fetch(
          `https://second-team-productions.onrender.com/crew?workRegion=${selectedRegion}&term=${searchTerm}&term=${searchTermLocation}&position=${selectedPosition}&department=${selectedDepartment}&unionStatus=${selectedUnion}&localStatus=${selectedLocal}`
        );
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const result = await response.json();
        // console.log('Data fetched:', result);
    
        // Filter data here after fetching
        const filteredData = result.filter((item) => {
          const workRegion = Array.isArray(item.workRegion)
            ? item.workRegion.join(', ').toLowerCase()
            : typeof item.workRegion === 'string'
            ? item.workRegion.toLowerCase()
            : '';
    
          const position = Array.isArray(item.position)
            ? item.position.join(', ').toLowerCase()
            : typeof item.position === 'string'
            ? item.position.toLowerCase()
            : '';

            const department = Array.isArray(item.department)
            ? item.department.join(', ').toLowerCase()
            : typeof item.department === 'string'
            ? item.department.toLowerCase()
            : '';
    
          const union = item.union && typeof item.union === 'string'
            ? item.union.toLowerCase()
            : '';
    
          const local = item.local && typeof item.local === 'string'
            ? item.local.toLowerCase()
            : '';
    
          const crewmember = item.crewmember && typeof item.crewmember === 'string'
            ? item.crewmember.toLowerCase()
            : '';
    
          const location = item.location && typeof item.location === 'string'
            ? item.location.toLowerCase()
            : '';
    
          return (
            (!searchTerm || crewmember.includes(searchTerm.toLowerCase())) &&
            (!searchTermLocation || location.includes(searchTermLocation.toLowerCase())) &&
            (!selectedPosition || position.includes(selectedPosition.toLowerCase())) &&
            (!selectedRegion || workRegion.includes(selectedRegion.toLowerCase())) &&
            (!selectedDepartment || department.includes(selectedDepartment.toLowerCase())) &&
            (!selectedUnion || union === selectedUnion.toLowerCase()) &&
            (!selectedLocal || local === selectedLocal.toLowerCase())
          );
        });
    
        setData(filteredData); // Store filtered data in state
        setIsLoaded(true);
        
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error.message);
        setIsLoaded(true);
      }
    };
    
    // Inside your component's render or return function
    if (error) {
      return <div>Error: {error}</div>;
    }
    

    return (
      <div
       style={{ 
          // marginTop: '10%',
          marginBottom: '5%'
          }}
      >

   {/* <HeroBackground image="allbg.jpg"  bgColor="#131212" /> */}

               <h1 className='justify-content-center'
               >TFDirect
               </h1>
               
        
        <Card
           className="p-4 card-body"
           style={{
             marginTop: '5%',
             marginBottom: '10%',
             marginRight: '5%',
             marginLeft: '5%',
             width: 'auto',
             height: 'auto',
             boxSizing: 'border-box',
             display: 'block', 
           }}
        >
            <CardText 
                   style={{     
                     display: 'inline-block',  
                     overflow: 'hidden',
                     boxSizing: 'border-box',
                     justifyContent: 'center', 
                   }}>
                 Welcome to TFDirect — your go-to directory for Texas film 
                 professionals to connect, collaborate, and find new opportunities.
                 If you're looking for a Texas resident to work on your project, you're 
                 in the right place.
               </CardText>
          <div className="row gy-4 mb-2">
            <div className="col-12 col-md-6 col-lg-6 d-flex flex-column align-items-start">
              <h5 className="mb-2">Name</h5>
              <input
               className="form-select about-card-edit"
               style={{
                background: 'none',
                border: 'none',
                color: 'silver',
                caretColor: 'grey',
                width: '100%',
                fontSize: '1.2rem',
              }}
                type="text"
                placeholder="Search by name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)} 
              />
            </div>
            <div className="col-12 col-md-6 col-lg-6 d-flex flex-column align-items-start">
              <h5 className="mb-2">Union Status</h5>
              <select
                name="union"
                value={selectedUnion}
                onChange={(e) => setSelectedUnion(e.target.value)}
                id="union"
                className="form-select mb-2 about-card-edit"
                style={{
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  appearance: 'none',
                  backgroundImage: 'none',
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: 'silver',
                  padding: '5px 30px 5px 10px',
                  width: '100%',
                  fontSize: 'clamp(1.1rem, 2.5vw, 1rem)'
                }}
              >
                <option value="">Select Option</option>
                <option value="union">Union</option>
                <option value="nonunion">Non-Union</option>
              </select>
             </div>
            </div>
   

          <div className="row gy-4 mb-2">
            <div className="col-12 col-md-6 col-lg-6 d-flex flex-column align-items-start">
              <h5 className="mb-2">Position</h5>
              <select
                value={selectedPosition}
                onChange={(e) => setSelectedPosition(e.target.value)}
                className="form-select about-card-edit"
                style={{
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  appearance: 'none',
                  backgroundImage: 'none',
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: 'silver',
                  padding: '5px 30px 5px 10px',
                  width: '100%',
                  fontSize: 'clamp(1.1rem, 2.5vw, 1rem)'
                }}
              >
                <option value="">Select Position</option>
                {position.map((pos) => (
                  <option key={pos} value={pos}>
                    {pos}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="col-12 col-md-6 col-lg-6 d-flex flex-column align-items-start">
              <h5 className="mb-2">Department</h5>
              <select
                   className="form-select mb-2 about-card-edit"
                   style={{
                     WebkitAppearance: 'none',
                     MozAppearance: 'none',
                     appearance: 'none',
                     backgroundImage: 'none',
                     backgroundColor: 'transparent',
                     border: 'none',
                     color: 'silver',
                     padding: '5px 30px 5px 10px',
                     width: '100%',
                     fontSize: 'clamp(1.1rem, 2.5vw, 1rem)'
                   }}
                value={selectedDepartment}
                onChange={(e) => setSelectedDepartment(e.target.value)}
              >
                <option value="">Select Department</option>
                {department.map((department) => (
                  <option key={department} value={department}>
                    {department}
                  </option>
                ))}
              </select>
             </div>
            </div>
          
        
          <div className="row gy-4 mb-2 ">
            <div className="col-12 col-md-6 col-lg-4 d-flex flex-column align-items-start">
              <h5 className="mb-2">Location</h5>
              <input
                type="text"
                placeholder="City"
                value={searchTermLocation}
                onChange={(e) => setSearchTermLocation(e.target.value)}
                className="form-select about-card-edit"
                    style={{
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      appearance: 'none',
                      backgroundImage: 'none',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: 'silver',
                      padding: '5px 30px 5px 10px',
                      width: '100%',
                      fontSize: 'clamp(1.1rem, 2.5vw, 1rem)'
                    }}
                   />
              </div>

            <div className="col-12 col-md-6 col-lg-4 d-flex flex-column align-items-start">
              <h5 className="mb-2">Work Region</h5>
              <select
                value={selectedRegion}
                onChange={(e) => setSelectedRegion(e.target.value)}
                className="form-select about-card-edit"
                style={{
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  appearance: 'none',
                  backgroundImage: 'none',
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: 'silver',
                  padding: '5px 30px 5px 10px',
                  width: '100%',
                  fontSize: 'clamp(1.1rem, 2.5vw, 1rem)'
                }}
              >
                <option value="">Select Region</option>
                {regions.map((region) => (
                  <option key={region} value={region}>
                    {region}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-12 col-md-6 col-lg-4 d-flex flex-column align-items-start">
              <h5 className="mb-2">Willing to Work as a Local</h5>
              <select
                name="local"
                value={selectedLocal}
                onChange={(e) => setSelectedLocal(e.target.value)}
                id="local"
                className="form-select mb-2 about-card-edit"
                style={{
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  appearance: 'none',
                  backgroundImage: 'none',
                  backgroundColor: 'transparent',
                  border: 'none',
                  color: 'silver',
                  padding: '5px 30px 5px 10px',
                  width: '100%',
                  fontSize: 'clamp(1.1rem, 2.5vw, 1rem)'
                }}
              >
                <option value="">Select Option</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
             </div>
            </div>
            
            <div className="d-flex flex-column align-items-center">
              <Button
                className="process-card-text hover-brighten"
                style={{
                  fontSize: '2.5vmin',
                  backgroundColor: 'rgb(48, 46, 46)',
                  cursor: 'pointer',
                  marginTop: '5%',
                  alignItems: 'center',
                  justifyContent: 'center',
                      gap: '0.5rem',
                    padding: '0.5rem 1rem',
                          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
         border: '2px solid rgba(28, 26, 26, 0.9)',
                        boxShadow: `
                          0 2px 0 rgba(255, 255, 255, 0.12) inset,
                          0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                          0 6px 12px rgba(0, 0, 0, 0.5),
                          0 12px 24px rgba(0, 0, 0, 0.35)
                        `,
                    borderRadius: '999px',
          transition: "opacity 0.6s ease 0.5s, transform 0.6s ease 0.5s",
                  // clipPath: "polygon(0 50%, 20px 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 20px 100%)",
                }}
                onClick={fetchData}
              >
                <h5 style={{ margin: '1%' }}>Search</h5>
              </Button>
            </div>
        </Card>
    
        {isLoaded && (
          <div className="row justify-content-center g-5"
          style={{
            margin: '5%',
          } }
          >
            {data.length > 0 ? (
              data.map((item) => (
<div key={item.id}   
  className="col-sm-6 col-md-6 col-lg-3 d-flex justify-content-center" 
  style={{
    marginBottom: '5%',
  }}>
  <Card
    className="card-body custom-border-directory justify-content-center"
    style={{
      padding: '1.5%',
      width: '100%',
      maxWidth: '320px',
      height: 'auto',
    }}
  >
  <Link
    to={`/crewProfile/${item && item.userId}`}
    style={{ textDecoration: 'none' }}
  >
<div
  style={{
    width: 'clamp(100px, 60%, 220px)',
    aspectRatio: '1',
    overflow: 'hidden',
    borderRadius: '50%',
    margin: '0 auto',
            borderRadius: '50%',
                backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          // borderRadius: "30px",
          border: '2px solid rgba(28, 26, 26, 0.9)',
          boxShadow: `
            0 2px 0 rgba(255, 255, 255, 0.03) inset,
            0 -2px 0 rgba(0, 0, 0, 0.5) inset,
            0 12px 24px rgba(0, 0, 0, 0.6),
            0 32px 64px rgba(0, 0, 0, 0.5),
            0 64px 100px rgba(0, 0, 0, 0.35)
          `,
  }}
>
  <Card.Img
    src={Array.isArray(item.profileI) ? item.profileI[0] : item.profileI}
    alt={`${item.crewmember}`}
    style={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      
    }}
  />
</div>
    <div style={{ justifyContent: 'center', alignContent: 'center', marginTop: '5%' }}>
      <CardText>
        <ListGroup>
          <ListGroupItem style={{ border: 'none', padding: '0', textAlign: 'center' }}>
            <h5 className="justify-content-center">{item.crewmember}</h5>
          </ListGroupItem>
          <ListGroupItem style={{ border: 'none', padding: '0', textAlign: 'center' }}>
          <h5 className="justify-content-center">
  {Array.isArray(item.position) ? item.position[0] : item.position}
</h5>
          </ListGroupItem>
          <ListGroupItem style={{ border: 'none', padding: '0', textAlign: 'center' }}>
            <h5 className="justify-content-center">{item.location}</h5>
          </ListGroupItem>
        </ListGroup>
      </CardText>
    </div>
  </Link>

  {/* Button now sits OUTSIDE the outer Link, avoiding nested <a> tags */}
  <div className="profile-hover-overlay">
    <Link to={`/crewProfile/${item && item.userId}`} style={{ textDecoration: 'none' }}>
      <Button
        className="process-card-text hover-brighten"
        style={{
          fontSize: '2.5vmin',
          backgroundColor: 'rgb(67, 66, 66)',
          border: '2px solid rgba(28, 26, 26, 0.9)',
                        boxShadow: `
                          0 2px 0 rgba(255, 255, 255, 0.12) inset,
                          0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                          0 6px 12px rgba(0, 0, 0, 0.5),
                          0 12px 24px rgba(0, 0, 0, 0.35)
                        `,
                    borderRadius: '999px',
          cursor: 'pointer',
        }}
      >
        <h5 style={{ margin: '1%' }}>Profile</h5>
      </Button>
    </Link>
  </div>
</Card>
                </div>
              ))
            ) : (
              <>
               <div
               style={{
                margin: '5%',
               }}
               >
               <h1 className="title-font justify-content-center">No results found</h1>
                </div>
             
              </>
           
            )}
          </div>
        )}
      </div>
    );
    
};

export default SearchDirectory;
